import { useEffect, useState } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import { Button } from "components/atoms/Button";
import { useNavigate } from "react-router-dom";
import { useGetStudyPlannerFormQuery } from "services/studyPlanner";
import { Spinner } from "components/atoms/Icon";
import { FetchError, GMATMaterialModal } from "components/molecules";
import { decodeToken } from "utils/functions/decodeToken";
import { GMAT_MATERIAL, GMAT_TEST_TYPE, MOBILE_WIDTH } from "utils/constants";
import { useScreenSize } from "hooks";
import { useGetGMACMaterialsQuery } from "services/homeApi";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
}

export const TitleSection = ({ theme }: IProps) => {
  const navigate = useNavigate();
  const screen = useScreenSize();
  const {
    isLoading: getFormIsLoading,
    isError: getFormIsError,
    data: formData,
  } = useGetStudyPlannerFormQuery();

  const payload = decodeToken();

  const isGMAT = payload && payload.hasOwnProperty("testtype") && payload.testtype === GMAT_TEST_TYPE;
  
  const { data: gmacMaterialsData } = useGetGMACMaterialsQuery(undefined, {
    skip: !isGMAT,
  });

  const hasGMACMaterials = gmacMaterialsData?.Materials && 
    Array.isArray(gmacMaterialsData.Materials) && 
    gmacMaterialsData.Materials.length > 0;

  const [showGMATMaterialModal, setShowGMATMaterialModal] = useState(false);

  const handleGMATMaterialModalClose = () => {
    setShowGMATMaterialModal(false);
  };

  useEffect(() => {
    if(screen.width <= MOBILE_WIDTH) {
      handleGMATMaterialModalClose()
    }
  }, [screen.width])

  return (
    <div className={classNames("title-section-wrapper")}>
      <div className="title-label">
        <Typography variant="h3Bold" label="Coursework" />
      </div>
      <div
        className={classNames({
          "title-btn":
            payload &&
            payload.hasOwnProperty("showstudyplanner") &&
            payload.showstudyplanner.toLowerCase() === "false",
        })}
      >
        {getFormIsLoading ? (
          <Spinner theme={theme} />
        ) : getFormIsError ? (
          <FetchError content="Oops! failed to load resources." />
        ) : formData &&
          payload &&
          payload.hasOwnProperty("showstudyplanner") &&
          payload.showstudyplanner.toLowerCase() === "true" ? (
          <Button
            icon={true}
            type="score"
            styles="tile-btn-style"
            label="Study Planner View"
            onClick={() => {
              if (formData.StartDate === null || formData.ExamDate === null) {
                navigate("/study-planner-form");
              } else {
                navigate("/study-planner");
              }
            }}
          />
        ) : null}
      </div>
      {isGMAT && hasGMACMaterials ? (
        <Button
          icon={false}
          type="score"
          label="Access Your Official GMAT Material"
          onClick={() => {
            if(screen.width <= MOBILE_WIDTH) {
              navigate(`/${GMAT_MATERIAL}`)
            } else {
              setShowGMATMaterialModal(true)
            }
          }}
        />
      ) : null}
      <GMATMaterialModal
        isOpen={showGMATMaterialModal}
        handleOnClose={handleGMATMaterialModalClose}
        theme={theme}
        materials={gmacMaterialsData?.Materials}
      />
    </div>
  );
};
